<template>
    <el-col :span="4" style="height: 100%;">
        <!-- 答疑解惑 -->
        <!-- <div class="doubtWrapper">
            <div class="head">
                <h4>答疑解惑</h4>
                <img src="../../assets/images/home/more.png" class="more" alt="">
            </div>
            <ul class="doubt">
                <li class="item">
                    <span class="tit">短信的申请门槛？</span>
                    <p class="desc">短信发送无门槛，签名京东备案、购买短信包后就可以发送了。短信发送...</p>
                </li>
                <li class="item">
                    <span class="tit">短信的申请门槛？</span>
                    <p class="desc">短信发送无门槛，签名京东备案、购买短信包后就可以发送了。短信发送...</p>
                </li>
                <li class="item">
                    <span class="tit">短信的申请门槛？</span>
                    <p class="desc">短信发送无门槛，签名京东备案、购买短信包后就可以发送了。短信发送...</p>
                </li>
                <li class="item">
                    <span class="tit">短信的申请门槛？</span>
                    <p class="desc">短信发送无门槛，签名京东备案、购买短信包后就可以发送了。短信发送...</p>
                </li>
            </ul>
        </div> -->
        <!-- 会员转化 -->
        <div class="conversionWrapper">
            <div class="head">
                <div class="left">
                    <span>提高会员转化</span>
                    <span class="hd">2</span>
                </div>
                <div class="right">
                    <img style="whidth:10px;height:10px" src="../../assets/images/home/huanyipi.png" alt="">
                    <span>
                        换一批
                    </span>
                </div>
            </div>
            <ul class="conversion">
                <li class="item" v-for="(item, index) in conversionList" :key="index">
                    <div class="item_bg">
                        <img class="item_pic" :src="item.icon" alt="">
                    </div>
                    <span class="txt">{{item.name}}</span>
                    <div class="hd_bg" v-if="item.isOpen">
                        <span>已开启</span>
                    </div>
                </li>
                <!-- <span class="more">更多功能敬请期待...</span>  
                <img src="../../assets/images/conversion_bg.png" class="img_bg" alt=""> -->
            </ul>
        </div>
    </el-col>
</template>

<script>
export default {
    data() {
        return {
            conversionList: [
                { 
                    name: '货到付款', 
                    isOpen: true, 
                    icon: require("../../assets/images/home/货到付款.svg")
                },
                { 
                    name: '常规催付', 
                    isOpen: false, 
                    icon: require('../../assets/images/home/常规催付.svg')
                },
                { 
                    name: '二次催付', 
                    isOpen: false, 
                    icon: require('../../assets/images/home/二次催付.svg')
                },
                { 
                    name: '付款关怀', 
                    isOpen: false, 
                    icon: require('../../assets/images/home/付款关怀.svg')
                },
                { 
                    name: '取消提醒', 
                    isOpen: false, 
                    icon: require('../../assets/images/home/取消提醒.svg')
                },
                { 
                    name: '迟发提醒', 
                    isOpen: true, 
                    icon: require('../../assets/images/home/迟发提醒.svg')
                },
                // { 
                //     name: '好评感谢', 
                //     isOpen: true, 
                //     icon: require('../../assets/images/home/haopingganxie.png')
                // },
                // { 
                //     name: '中差评安抚', 
                //     isOpen: true, 
                //     icon: require('../../assets/images/home/zhongchapinganfu.png')
                // },
            ]
        }
    },
    mounted() {
    },
    methods: {

    },
}
</script>


<style lang="scss" scoped>

.conversionWrapper {
    display: flex;
    flex-direction: column;
    height:100%;
    background:rgba(255,255,255,1);
    box-shadow:0px 4px 8px rgba(0,0,0,0.1);
    border-radius:6px;
    .head {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 30px 0 21px;
        height: 54px;
        border-bottom: 1px solid #f3f3f3;
        font-size: 16px;
        font-weight: 800;
        color: #333;
        .left{
            display: flex;
            align-items: center;
        }
        .hd {
            margin-left: 4px;
            min-width: 16px;
            height: 16px;
            line-height: 16px;
            background: #FE4D45;
            border-radius: 50%;
            text-align: center;
            font-size: 12px;
            color: #fff;
            font-weight: 400;
        }
        .right{
            color: #999;
            font-size: 14px;
            float: right;
            font-weight: 100;
            // font-family: PingFang SC;
        }
    }
    .conversion {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        box-sizing: border-box;
        padding: 25px 16px 20px;
        position: relative;
        .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            position: relative;
            // margin: 0 28px 10px 0;
            width: 50%;
            height: 100px;
            cursor: pointer;
            transition: all .2s;
            &:nth-child(4n+4) {
                margin-right: 0;
            }
            &:hover {
                box-shadow:0px 0px 12px rgba(93,13,13,0.16);
            }
            .txt {
                // margin-top: 16px;
                font-size: 14px;
                color: #333;
                white-space: nowrap;
            }
            .item_bg{
                width: 64px;
                height: 64px;
                background: #F5F7FA;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                .item_pic{
                    width: 28px;
                    height: 28px;
                }
            }
        }
        .more {
            margin: auto 0 auto 20px;
            height: 20px;
            color: #999;
            font-size: 14px;
        }
        .hd_bg {
            position: absolute;
            top: 0;
            right: 0;
            width: 36px;
            height: 19px;
            line-height: 18px;
            background: url('../../assets/images/hd_bg.png') no-repeat;
            background-size: 100%;
            background-position: right;
            text-align: right;
            span {
                display: inline-block;
                color: #fff;
                font-size: 10px;
                font-weight: 400;
                transform: scale(0.8);
            }
        }
        .img_bg {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 100px;
            height: 100px;
        }
    }
    // @media screen and (max-width: 1700px) {
    //     .conversion {
    //         .item {
    //             margin: 0 20px 10px 0;
    //         }
    //     }
    // }
}
</style>